import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ep-two-two',
  templateUrl: './ep-two-two.component.html',
  styleUrls: ['./ep-two-two.component.scss']
})
export class EpTwoTwoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
